import countriesData from '../countries.json';

interface CountryData {
  iso2: string;
  name: string;
  dial_code: string;
}

export interface CountryOption {
  value: string; // "KR", "US", or "Country Name"
  label: string; // "Country Name (Dial Code)"
  dialCode: string; // "+82", etc.
}

const typedCountriesData = countriesData as CountryData[];

export const getCountryOptions = (): CountryOption[] => {
  return typedCountriesData.map((c) => {
    let value = c.name;
    // Specific logic for KR and US: use ISO code as value
    if (c.iso2 === 'KR' || c.iso2 === 'US') {
      value = c.iso2;
    }

    const label = `${c.name} (${c.dial_code})`;

    return { value, label, dialCode: c.dial_code };
  });
};

export const getCountryLabel = (value: string): string => {
  if (!value) return '';
  const options = getCountryOptions();
  const found = options.find((opt) => opt.value === value);
  return found ? found.label : value;
};
